document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('iframe, img').forEach(iframe => {
    if (iframe.hasAttribute('data-src')) {
      iframe.src = iframe.getAttribute('data-src');
    }
  });
})
